import React from 'react'
import Workflowtabs from '../components/createworkflow/Workflowtabs';
import {DataProvider} from '../components/createworkflow/DataContext';
import { FormProvider } from '../components/createworkflow/FormContext';
import { MenuProvider } from '../components/createworkflow/MenuContext';

function CreateWorkflow() {
  return (
    <FormProvider>
      <MenuProvider>
        <DataProvider>
          <Workflowtabs />
        </DataProvider>
      </MenuProvider>
    </FormProvider>
  )
}

export default CreateWorkflow;
